import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 20l16 0","key":"svg-0"}],["path",{"d":"M12 14l0 -10","key":"svg-1"}],["path",{"d":"M12 14l4 -4","key":"svg-2"}],["path",{"d":"M12 14l-4 -4","key":"svg-3"}]]

const IconArrowBarToDown = createReactComponent('outline', 'arrow-bar-to-down', 'ArrowBarToDown', __iconNode);

export default IconArrowBarToDown;